module.exports = __webpack_public_path__ + "static/media/Soundcloud.52cdbf31.svg";